export default {
  // Guarda todos os eventos da página
  events: {
    // "NEW_POSITION": [
    // 	{
    // "account_id": "5",
    // "avg": 5494,
    // "event": "NEW_POSITION",
    // "investment_id": 208,
    // "sl": 5294,
    // "tp": 5694,
    // "type": "BUY",
    // "volume": 2
    // 	}
    // ]
  },
  notifications: [],
};
